export default __webpack_public_path__ + "static/media/banner.cc6f9c58.png";